import { render, staticRenderFns } from "./fbpDeclarationLock.vue?vue&type=template&id=3125543a&scoped=true"
import script from "./fbpDeclarationLock.vue?vue&type=script&lang=js"
export * from "./fbpDeclarationLock.vue?vue&type=script&lang=js"
import style0 from "./fbpDeclarationLock.vue?vue&type=style&index=0&id=3125543a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3125543a",
  null
  
)

export default component.exports